var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 3.84652H12.6V2.15422C12.6 1.21499 11.799 0.461914 10.8 0.461914H7.2C6.201 0.461914 5.4 1.21499 5.4 2.15422V3.84652H1.8C0.801 3.84652 0.00899999 4.5996 0.00899999 5.53883L0 14.8465C0 15.7857 0.801 16.5388 1.8 16.5388H16.2C17.199 16.5388 18 15.7857 18 14.8465V5.53883C18 4.5996 17.199 3.84652 16.2 3.84652ZM10.8 3.84652H7.2V2.15422H10.8V3.84652Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.ffd41bfe419eda5fd599fdcdcf7b6f98.svg";
export { ForwardRef as ReactComponent };